export default ['1.32',

  '1.31',

  '1.30'];
